import { Permission } from './permission.entity';

export class User {
  constructor(
    public id: string,
    public name: string,
    public surname: string,
    public email: string,
    public indicativeNumber: string,
    public cellphone: string,
    public documentType: string,
    public documentNumber: string,
    public companyName: string,
    public companyNit: string,
    public permissions: Permission,
    public role: string | null,
    public department?: string,
    public city?: string,
    public address?: string,
    public idToken?: string,
    public accessToken?: string,
    public refreshToken?: string
  ) {}
}
